import { FiResponse, RebateResponse, WriteupResponse } from '@/types/writeup';
import { CreditAppFormData } from '@/types/cbc';

export interface SchedulerCalendarData {
	date: string;
	time: string;
}

export interface RawLeadData {
	writeup: WriteupResponse;
	rebates: RebateResponse[];
	protections: FiResponse[];
	shortUrl: string;
	clientId: string;
	websiteId: string;
	primaryColor: string;
	vehicleDetailsUrl: string;
	appointmentId: number|undefined;
	lenderSocketServiceProvider: string;
	routeOneFieldsData: RouteOneFieldsData;
	formData: RequestData;
}

export interface RouteOneFieldsData {
	financedAmount: number | undefined;
	residualPercentage: number | undefined;
	leaseRate: number | undefined;
	leaseRateMoneyFactor: number | undefined;
	estimatedPayment: number | undefined;
	basePayment: number | undefined;
	rebate: number | undefined;
	apr: number | undefined;
}

export enum TradeInConditions {
	'Poor'= 2,
	'Average'= 4,
	'Great' = 5,
}

export interface TestDriveFormData {
	writeupId: number | undefined;
	type: number;
	date: string;
	time: string;
	customerAddress?: string;
	customerAddressNotes?: string;
}

// TODO: create interface with all the fields
export interface RequestData extends
	Partial<CreditAppFormData>,
	Partial<SchedulerCalendarData>,
	Partial<TestDriveFormData> {
	[key: string]: string | number | object | void | boolean | null;
}
